import http from "./http"
import { Contract, CreateContractDTO, UpdateContractDTO } from "./../models/contract"

class ContractService {
  private readonly baseUrl = "/contract"

  async createContract(dto: CreateContractDTO) {
    const { data } = await http.post<Contract>(`${this.baseUrl}`, dto)
    return data
  }

  async updateContract(contractId: string, dto: UpdateContractDTO) {
    const { data } = await http.put<Contract>(`${this.baseUrl}/${contractId}`, dto)
    return data
  }

  async deleteContract(contractId: string) {
    const { data } = await http.delete<{ message: string }>(`${this.baseUrl}/${contractId}`)
    return data
  }
}

export default new ContractService()
